export default class {

    id = null;
    first_name = null;
    last_name = null;
    email = null;
    photo = null;
    photo_url = null;
    file = null;
    meta = {
        phone: null
    };
    created_at = null;
    updated_at = null;
    deleted_at = null;
    status = 'active';

    constructor(data) {
        this.id = data?.id || this.id;
        this.first_name = data?.first_name || this.first_name;
        this.last_name = data?.last_name || this.last_name;
        this.email = data?.email || this.email;
        this.photo = data?.photo || this.photo;
        this.photo_url = data?.photo_url || this.photo_url;
        this.file = data?.file || this.file;
        this.meta = {
            phone: data?.meta?.phone || this.meta.phone,
        };
        this.created_at = data?.created_at || this.created_at;
        this.updated_at = data?.updated_at || this.updated_at;
        this.deleted_at = data?.deleted_at || this.deleted_at;
        this.status = data?.status || this.status;
        
        return this;
    }

    get name() {
        return `${this.first_name} ${this.last_name}`;
    }
}